import { CommonModule } from "@angular/common";
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import Swiper from "swiper";
import { API_URLS, FILE_PATH_PLAN } from "../../../../../config/app.constants";
import { SafeHtmlPipe } from "../../../../../shared/pipes/safe-html.pipe";
import { HttpinterceptorService } from "../../../../../shared/services/httpinterceptor.service";
import { StarRatingComponent } from "../../../star-rating/star-rating.component";

@Component({
  selector: "app-home-plan",
  templateUrl: "./home-plan.component.html",
  styleUrls: ["./home-plan.component.scss"],
  standalone: true,
  imports: [CommonModule, StarRatingComponent, RouterLink, SafeHtmlPipe],
})
export class HomePlanComponent implements OnInit, AfterViewInit {
  @ViewChild("swiperContainer") swiperContainer: ElementRef;

  filePath: string;
  plans: any[];

  constructor(private http: HttpinterceptorService, private router: Router) {
    this.filePath = FILE_PATH_PLAN;
  }

  ngOnInit() {
    this.getPlanDetails();
  }

  ngAfterViewInit(): void {
    // Called after ngAfterContentInit when the component's view has been initialized.
    // Applies to components only.
    // Add 'implements AfterViewInit' to the class.
    // Ensure Swiper is initialized after data is fetched
    this.initSwiper();
  }

  initSwiper() {
    new Swiper(this.swiperContainer.nativeElement, {
      // Swiper configuration options here
      allowTouchMove: false,
      slidesPerView: 1,
      effect: "fade",
      loop: true,
    });
  }

  getPlanDetails() {
    this.http
      .post(API_URLS.GET_PLAN_DETAILS, {}, false)
      .subscribe((response) => {
        if (response.type === "success") {
          if (response.data) {
            this.plans = response.data;
          }
        }
      });
  }

  goToPlan(plan) {
    let url;
    if (plan.pet_types.length > 1) {
      url = `/plans/${plan.slug ? plan.slug : plan.id}/${
        plan.pet_types[0].slug
      }`;
    } else {
      url = `/plans/${plan.slug ? plan.slug : plan.id}`;
    }
    this.router.navigate([url]);
  }

  onSlidePrev() {
    this.swiperContainer.nativeElement.swiper.slidePrev(1000);
  }
  onSlideNext() {
    this.swiperContainer.nativeElement.swiper.slideNext(1000);
  }
}
